import { defaultEntityState } from '@core/state/entities/entity';
import {
  mergeEntityState,
  normalizeAndMergeEntity,
} from '@core/state/entities/entity.helpers';
import { createReducer, on } from '@ngrx/store';
import { authApiActions } from '@core/auth/auth.actions';
import { entityKey } from '@core/state/entities/entity-name-map';
import { profileUpdatedDtoSchema } from '@core/auth/auth.effects';
import { IInvestigatorSecureDetails } from '@core/state/entities/investigator-secure-details/investigator-secure-details.entity';

export const investigatorSecureDetailsReducer = createReducer(
  defaultEntityState<IInvestigatorSecureDetails>(),
  on(
    authApiActions.signInRecorded,
    (state, props) =>
      mergeEntityState(entityKey.investigatorSecureDetails, state, props)
  ),
  on(
    authApiActions.profilePictureUpdated,
    authApiActions.profileEmailVerifiedAndAdded,
    authApiActions.profileNameUpdated,
    authApiActions.emailRemovedFromProfile,

    (state, props) =>
      normalizeAndMergeEntity(
        entityKey.investigatorSecureDetails,
        state,
        props,
        profileUpdatedDtoSchema
      )
  )
);
